import api from './api';

const B = '/api/cpd-register';
const g = (u, params) => api.get(`${B}${u}`, { params }).then((r) => r.data);
const p = (u, body) => api.post(`${B}${u}`, body).then((r) => r.data);
const put = (u, body) => api.put(`${B}${u}`, body).then((r) => r.data);

export const cpdAPI = {
  me: () => g('/me'),
  dashboard: (user_id) => g('/dashboard', { user_id }),
  activities: (params) => g('/activities', params),
  exportCsv: (params) => api.get(`${B}/activities`, { params: { ...params, format: 'csv' }, responseType: 'blob' }).then((r) => r.data),
  activity: (id) => g(`/activities/${id}`),
  create: (body) => p('/activities', body),
  update: (id, body) => put(`/activities/${id}`, body),
  remove: (id) => api.delete(`${B}/activities/${id}`).then((r) => r.data),
  action: (id, action, reason) => p(`/activities/${id}/action`, { action, reason }),
  eligibility: (params) => g('/eligibility', params),
  upload: (id, files, doc_category) => {
    const fd = new FormData();
    files.forEach((f) => fd.append('files', f));
    fd.append('doc_category', doc_category);
    return api.post(`${B}/activities/${id}/evidence`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  blob: (eid, inline) => api.get(`${B}/evidence/${eid}/download`, { params: { inline }, responseType: 'blob' }).then((r) => r.data),
  removeEvidence: (eid) => api.delete(`${B}/evidence/${eid}`).then((r) => r.data),
  evidence: (params) => g('/evidence', params),
  team: () => g('/team'),
  staff: () => g('/staff'),
  profile: (uid) => g(`/profiles/${uid}`),
  saveProfile: (uid, body) => put(`/profiles/${uid}`, body),
  assign: (uid, body) => p(`/profiles/${uid}/frameworks`, body),
  unassign: (ufid) => api.delete(`${B}/user-frameworks/${ufid}`).then((r) => r.data),
  frameworks: () => g('/frameworks'),
  versions: (fid) => g(`/frameworks/${fid}/versions`),
  createFramework: (body) => p('/frameworks', body),
  updateFramework: (fid, body) => put(`/frameworks/${fid}`, body),
  resetFramework: (fid) => p(`/frameworks/${fid}/reset`),
  settings: () => g('/settings'),
  saveSettings: (body) => put('/settings', body),
  exceptions: (user_id) => g('/exceptions', { user_id }),
  addException: (body) => p('/exceptions', body),
  approveException: (id) => p(`/exceptions/${id}/approve`),
  alerts: (status) => g('/alerts', { status }),
  alertOp: (id, op) => p(`/alerts/${id}/${op}`),
  runAlerts: () => p('/alerts/run'),
  audit: (params) => g('/audit', params),
  loadDemo: () => p('/demo/load'),
  removeDemo: () => p('/demo/remove'),
  migrateLegacy: () => p('/migrate-legacy'),
  requirements: () => g('/training/requirements'),
  createRequirement: (b) => p('/training/requirements', b),
  updateRequirement: (id, b) => put(`/training/requirements/${id}`, b),
  assignTraining: (b) => p('/training/assign', b),
  myTraining: (user_id) => g('/training/my', { user_id }),
  matrix: () => g('/training/matrix'),
  trainingAction: (id, b) => p(`/training/assignments/${id}/action`, b),
  attended: (id, attended) => p(`/training/assignments/${id}/attended`, { attended }),
  trainingEvidence: (id, files) => { const fd = new FormData(); files.forEach((f) => fd.append('files', f)); return api.post(`${B}/training/assignments/${id}/evidence`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data); },
  runTraining: () => p('/training/run'),
  reports: () => g('/reports'),
  report: (key, params) => g(`/reports/${key}`, params),
  reportFile: (key, params, format) => api.get(`${B}/reports/${key}`, { params: { ...params, format }, responseType: 'blob' }).then((r) => r.data),
  auditPack: (body) => api.post(`${B}/audit-pack`, body, { responseType: 'blob' }).then((r) => r.data),
  importUpload: (file) => { const fd = new FormData(); fd.append('file', file); return api.post(`${B}/import/upload`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data); },
  importDryRun: (id, mapping) => p(`/import/${id}/dry-run`, { mapping }),
  importCommit: (id, mapping, historical) => p(`/import/${id}/commit`, { mapping, historical }),
  importErrors: (id) => api.get(`${B}/import/${id}/errors.csv`, { responseType: 'blob' }).then((r) => r.data),
  readCertificate: (file) => { const fd = new FormData(); fd.append('file', file); return api.post(`${B}/assist/read-certificate`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data); },
  assistStatus: () => g('/assist/status'),
  ask: (question, user_id) => p('/assist/ask', { question, user_id }),
  recommendations: (user_id) => g('/assist/recommendations', { user_id }),
  complianceSummary: () => g('/compliance-summary'),
  integrations: () => g('/integrations'),
};

export const errMsg = (e, fallback = 'Something went wrong') => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === 'string') return d;
  return d.message || fallback;
};

export const download = (blob, name) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
};

export const ACT_STATUS = {
  draft: 'Draft', submitted: 'Submitted', approved: 'Approved', rejected: 'Rejected', changes_requested: 'Changes requested', recorded: 'Recorded',
};
